import { CreateRoleForm } from '..';
import {
  defaultHolidayOvertimeRatePercentage,
  defaultHolidayRatePercentage,
  defaultNormalRatePercentage,
  defaultOvertimeRatePercentage,
} from '../../company-management/action-team/reducers/action-team';

export const emptyCreateRoleFormValue: CreateRoleForm = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  costPrice: null,
  // @ts-expect-error
  sellPrice: null,
  normalRatePercentage: defaultNormalRatePercentage,
  overtimeRatePercentage: defaultOvertimeRatePercentage,
  // @ts-expect-error
  defaultCostPricePerHour: null,
  // @ts-expect-error
  defaultSellPricePerHour: null,
  // @ts-expect-error
  costPricePerHour: null,
  // @ts-expect-error
  sellPricePerHour: null,
  // @ts-expect-error
  overtimeCostPricePerHour: null,
  // @ts-expect-error
  overtimeSellPricePerHour: null,
  // @ts-expect-error
  transportCostPricePerDistanceUnit: null,
  // @ts-expect-error
  transportSellPricePerDistanceUnit: null,
  transportDistance: 120,
  scheduleStartLocation: null,
  fullness: 0,
  quantity: 1,
  // @ts-expect-error
  amount: null,
  roleName: '',

  holidayHourPricePercentage: defaultHolidayRatePercentage,
  // @ts-expect-error
  holidayHourPriceUnitPrice: null,
  // @ts-expect-error
  holidayHourPriceBillablePrice: null,
  holidayOvertimePricePercentage: defaultHolidayOvertimeRatePercentage,
  // @ts-expect-error
  holidayOvertimePriceUnitPrice: null,
  // @ts-expect-error
  holidayOvertimePriceBillablePrice: null,

  // @ts-expect-error
  ownCarViaUnitPrice: null,
  // @ts-expect-error
  ownCarViaBillablePrice: null,
  // @ts-expect-error
  ownCarDirectUnitPrice: null,
  // @ts-expect-error
  ownCarDirectBillablePrice: null,
  // @ts-expect-error
  actionTeamRole: null,
  // @ts-expect-error
  ratesheet: null,
};
